import { useMutation, useQueryClient } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../CommonUtils/httpBodyOptions';
import { queryKeys } from './queryKeys';
import { useClientId } from '../../_hooks/useClientId';

interface FetcherParams {
  goalId: string;
}

const deleteCharitableGivingGoal = (clientId: number) => ({ goalId }: FetcherParams) => {
  return authFetch('/Consumer/GoalUpdate/Delete', {
    method: 'POST',
    ...httpBodyOptions({ clientId, goalId }),
  });
};

export const useDeleteCharitableGivingGoalMutation = () => {
  const queryClient = useQueryClient();

  const clientId = useClientId();

  return useMutation(deleteCharitableGivingGoal(clientId), {
    async onSuccess() {
      await queryClient.invalidateQueries(queryKeys.goals(clientId));
    },
  });
};
